/**
 * OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreen
 */

import { useOrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenLogic';
import type { OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsBeginnerCompleteOrbitalSLDocView as OrbDocTutorialsBeginnerCompleteOrbitalSLDocViewEntity } from '@app/shared';
import { OrbDocTutorialsBeginnerCompleteOrbitalSLDocBodyView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalSLDocBodyView';
import { OrbDocTutorialsBeginnerCompleteOrbitalSLDocFooterView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalSLDocFooterView';
import { OrbDocTutorialsBeginnerCompleteOrbitalSLDocHeaderView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenViewProps {
  config?: Partial<OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenConfig>;
}

export function OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenView({ config: propsConfig }: OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsBeginnerCompleteOrbitalSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsBeginnerCompleteOrbitalSL" trait="OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsBeginnerCompleteOrbitalSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsBeginnerCompleteOrbitalSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsBeginnerCompleteOrbitalSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenView;
